import Vue from 'vue'
import Category from '../models/Blog/Category'
import Article from '../models/Blog/Article'

export const actions = {
  async fetchCategories ({}, payload) {
    try {
      const categories = new Category()
      if (payload) {
        if (Object.prototype.hasOwnProperty.call(payload, 'root')) {
          categories.where('rootItem', payload.root)
        }
        if (Object.prototype.hasOwnProperty.call(payload, 'about_us')) {
          categories.where('about_us', payload.about_us)
        }
      }

      const result = await categories.get()
      return result.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  async fetchCategory ({}, payload) {
    const result = await this.$axios.get('/blog/categories/' + payload)
    return result.data
  },
  async fetchLatestArticles ({}) {
    const articles = await Article.custom('blog/articles/latest')
      .include('media', 'category')
      .get()
    return articles.data
  },
  async fetchArticles ({}, payload) {
    try {
      const articles = Article.include('media', 'category')
      if (payload) {
        if (payload.category_id) {
          articles.where('category_id', payload.category_id)
        }
        if (payload.page) {
          articles.page(parseInt(payload.page))
        }
        if (Object.prototype.hasOwnProperty.call(payload, 'about_us')) {
          articles.where('category.about_us', payload.about_us)
        }
      }
      const result = await articles.get()
      return result
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  },
  async fetchArticle ({}, payload) {
    const result = await Article.include('media', 'category').find(payload)
    return result.data
  }
}
